// Module
var code = `<page-header model="ctrl.navModel"></page-header>

<div class="page-container page-body">

  <div class="grafana-info-box span8">
    Grafana is a multi-tenant system where most can be configured per organization. These
    admin pages are for server admins where you can manage orgs, & all users across all orgs.
  </div>

</div>

<footer>
`;
// Exports
var _module_exports =code;;
var path = 'public/app/features/admin/partials/admin_home.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;